export const LOGIC_SET_STATUS = {
    INACTIVE: 'inactive',
    NOT_IMPLEMENTED: 'not-implemented',
    IMPLEMENTED: 'implemented',
    INOPERABLE: 'inoperable'
};
